import { ProgramTypes } from '../models/gradingPolicy';

export const DEFAULT_CONESTOGA_POLICIES = [
  {
    id: 'conestoga-current-diploma',
    name: 'Default Grading System – Current (Diploma/Certificate)',
    description:
      'Current grading system based on Grading Appendix A for diploma, certificate, and advanced diploma programs.',
    sourceUrl:
      'https://www.conestogac.on.ca/policies/grading-appendix-a-conestoga-grading-system',
    isHistoric: false,
    effectiveFrom: '2024-11-20',
    associatedProgramTypes: ['Certificate', 'Diploma', 'Advanced Diploma'],
    programTypes: ['Certificate', 'Diploma', 'Advanced Diploma'],
    isActive: true,
    gradeScale: [
      {
        alphaGrade: 'A+',
        gradePoint: 4.0,
        lowPercent: 90,
        highPercent: 100,
        description:
          'Achievement in course learning outcomes is outstanding and warrants unique and distinguished recognition.'
      },
      {
        alphaGrade: 'A',
        gradePoint: 3.75,
        lowPercent: 80,
        highPercent: 89,
        description:
          'Considerable evidence of original thinking; demonstrated capacity to analyze, integrate and extend concepts; outstanding grasp of subject matter; consistent demonstration of practice with no supervision and guidance.'
      },
      {
        alphaGrade: 'B+',
        gradePoint: 3.5,
        lowPercent: 75,
        highPercent: 79,
        description:
          'Achievement in course learning outcomes is acceptable and meets above average standards with solid grasp of subject matter; minimal supervision required.'
      },
      {
        alphaGrade: 'B',
        gradePoint: 3.0,
        lowPercent: 70,
        highPercent: 74,
        description:
          'Evidence of solid grasp of subject matter; reasonable understanding of relevant ideas; some evidence of critical capacity and analysis; clear connections of ideas and numerous extensions; reasonable demonstration of practice with minimal supervision and guidance.'
      },
      {
        alphaGrade: 'C+',
        gradePoint: 2.5,
        lowPercent: 65,
        highPercent: 69,
        description:
          'Achievement in course learning outcomes meets average standards with some understanding and periodic supervision needed; minimal connections of ideas and extensions.'
      },
      {
        alphaGrade: 'C',
        gradePoint: 2.0,
        lowPercent: 60,
        highPercent: 64,
        description:
          'Achievement in course learning outcomes meets average standards with minimal connections of ideas and extensions; periodic supervision and guidance.'
      },
      {
        alphaGrade: 'D',
        gradePoint: 1.0,
        lowPercent: 55,
        highPercent: 59,
        description:
          'Marginal achievement with minimal understanding and constant supervision required.'
      },
      {
        alphaGrade: 'F',
        gradePoint: 0.0,
        lowPercent: 0,
        highPercent: 54,
        description: 'Achievement in course learning outcomes is inadequate and fails to meet minimal standards.'
      }
    ]
  },
  {
    id: 'conestoga-current-degree',
    name: 'Default Grading System – Current (Degree)',
    description:
      'Current grading system based on Grading Appendix A for degree and graduate certificate programs (minimum passing grade of 60%).',
    sourceUrl:
      'https://www.conestogac.on.ca/policies/grading-appendix-a-conestoga-grading-system',
    isHistoric: false,
    effectiveFrom: '2024-11-20',
    associatedProgramTypes: ['Degree', 'Graduate Certificate'],
    programTypes: ['Degree', 'Graduate Certificate'],
    isActive: true,
    gradeScale: [
      {
        alphaGrade: 'A+',
        gradePoint: 4.0,
        lowPercent: 90,
        highPercent: 100,
        description:
          'Achievement in course learning outcomes is outstanding and warrants unique and distinguished recognition.'
      },
      {
        alphaGrade: 'A',
        gradePoint: 3.75,
        lowPercent: 80,
        highPercent: 89,
        description:
          'Considerable evidence of original thinking; demonstrated capacity to analyze, integrate and extend concepts; outstanding grasp of subject matter; consistent demonstration of practice with no supervision and guidance.'
      },
      {
        alphaGrade: 'B+',
        gradePoint: 3.5,
        lowPercent: 75,
        highPercent: 79,
        description:
          'Achievement in course learning outcomes is acceptable and meets above average standards with solid grasp of subject matter; minimal supervision required.'
      },
      {
        alphaGrade: 'B',
        gradePoint: 3.0,
        lowPercent: 70,
        highPercent: 74,
        description:
          'Evidence of solid grasp of subject matter; reasonable understanding of relevant ideas; some evidence of critical capacity and analysis; clear connections of ideas and numerous extensions; reasonable demonstration of practice with minimal supervision and guidance.'
      },
      {
        alphaGrade: 'C+',
        gradePoint: 2.5,
        lowPercent: 65,
        highPercent: 69,
        description:
          'Achievement in course learning outcomes meets average standards with some understanding and periodic supervision needed; minimal connections of ideas and extensions.'
      },
      {
        alphaGrade: 'C',
        gradePoint: 2.0,
        lowPercent: 60,
        highPercent: 64,
        description: 'Satisfactory performance meeting the minimum passing threshold for degree programs.'
      },
      {
        alphaGrade: 'F',
        gradePoint: 0.0,
        lowPercent: 0,
        highPercent: 59,
        description: 'Achievement in course learning outcomes is inadequate and fails to meet minimal standards.'
      }
    ]
  },
  // Historic or specialized policies can be added here if Conestoga publishes updates.
];

export const isProgramType = (value) => ProgramTypes.includes(value);
